import { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';

import { ContactsAccordion } from '@components/UserSettings/Contacts/Accordion';

export const UserContactDetails = () => {
  const [showEmptyContactForm, setShowEmptyContactForm] = useState(false);
  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Header className="bg-didxl text-white">
            Contact details
          </Card.Header>
          <Card.Body>
            <ContactsAccordion />
            <Col className="mt-3">
              <Button
                variant="didxl"
                onClick={() => setShowEmptyContactForm(!showEmptyContactForm)}
                size="sm"
              >
                Add
              </Button>
            </Col>
            {showEmptyContactForm ? (
              <Row className="mt-4">
                <ContactsAccordion empty />
              </Row>
            ) : null}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
